var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8541 21.7487C12.2683 21.7559 12.6099 21.426 12.6171 21.0119L12.7939 10.8847L16.1429 14.3527C16.4306 14.6507 16.9054 14.6589 17.2034 14.3712C17.5013 14.0835 17.5096 13.6087 17.2219 13.3107L12.7066 8.63501C12.5394 8.46188 12.3091 8.38655 12.087 8.41026C11.8658 8.3788 11.633 8.44605 11.4598 8.61324L6.78414 13.1285C6.48618 13.4163 6.47789 13.8911 6.76563 14.189C7.05336 14.487 7.52816 14.4953 7.82612 14.2075L11.2941 10.8585L11.1173 20.9857C11.1101 21.3998 11.44 21.7414 11.8541 21.7487ZM3.3978 4.84851C3.39057 5.26266 3.72044 5.60425 4.13459 5.61148L20.1322 5.89072C20.5463 5.89795 20.8879 5.56807 20.8951 5.15392C20.9024 4.73977 20.5725 4.39818 20.1583 4.39095L4.16077 4.11171C3.74662 4.10448 3.40503 4.43436 3.3978 4.84851Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.926aee1bcebdfcb3b62095d63a33e01e.svg";
export { ForwardRef as ReactComponent };